import type { ModalProps } from "@interstate/components/Modal/Types/modalTypes";
import type { SlideOutProps } from "@interstate/components/SlideOut/Types/slideOutTypes";
import type { UseQueryResult } from "@tanstack/react-query";

export interface useCompareToolProps {
  onClosed?: () => void;
  compareFromComponent: React.ReactNode;
  compareToComponent: React.ReactNode;
  config?: compareToolConfig;
  title?: string;
  hasBridgeBar?: boolean;
}

export interface compareToolProps {
  hasBridgeBar: boolean;
  title?: string;
  compareFromComponent: React.ReactNode;
  compareToComponent: React.ReactNode;
  itemsToCompare: compareItemsInterface;
  compareToolConfig: compareToolConfig;
  closeModal: () => void;
}

export interface CompareToolContentProps {
  compareFromComponent: React.ReactNode;
  compareToComponent: React.ReactNode;
  itemsToCompare: compareItemsInterface;
}

export interface CompareToolContentGroupProps {
  label?: string;
  value: Partial<UseQueryResult<compareItem[], Error>>;
}

export interface compareItemsInterface {
  from?: CompareToolContentGroupProps;
  to?: CompareToolContentGroupProps;
}
export interface compareItem {
  label: string;
  value?: string | number | boolean;
  group?: string;
}
export type compareToolConfig = SlideOutConfig | ModalConfig;
export interface SlideOutConfig extends Omit<SlideOutProps, "show" | "onHide"> {
  type: "SlideOut";
}
export interface ModalConfig extends Omit<ModalProps, "show" | "onHide"> {
  type: "modal";
}

export const isModalConfig = (
  config: compareToolConfig
): config is ModalConfig => config.type === "modal";
export const isSlideOutConfig = (
  config: compareToolConfig
): config is SlideOutConfig => config.type === "SlideOut";

export interface CompareToolContentItemsProps {
  label: string;
  from?: string | number | boolean;
  to?: string | number | boolean;
}
export interface CompareToolContentItemProps {
  label: string;
  value?: string | number | boolean;
}
export type filterType = "All" | "similar" | "different";
